module.exports = __webpack_public_path__ + "img/h2-video.4e8a50b9.jpg";